<!-- SVG icon using mask (theme-colored custom / sidebar assets) -->
@if (iconPath) {
  <span
    class="svg-icon"
    [style.width]="size"
    [style.height]="size"
    [style.backgroundColor]="color"
    [style.WebkitMaskImage]="'url(' + iconPath + ')'"
    [style.maskImage]="'url(' + iconPath + ')'">
  </span>
}

<!-- Material fallback -->
@if (iconSvg) {
  <span
    class="icon-wrapper"
    [style.width]="size"
    [style.height]="size"
    [style.color]="color"
    [innerHTML]="iconSvg">
  </span>
}
